module.exports = __webpack_public_path__ + "img/12.650d9527.png";